import React from "react";
import classNames from "classnames";

import { PromotedStrain } from "custom-types/Directus";
import useFilters from "hooks/useFilters";

import Button from "components/botanic/Button";
import Carousel from "components/botanic/Carousel";

const PromotedStrainCarousel: React.FC<{
  asLink?: boolean;
  className?: string;
  onClick?: (strain: PromotedStrain) => void;
  promotedStrains: PromotedStrain[];
  title?: string;
}> = ({ asLink, className, onClick, promotedStrains, title }) => {
  const { selectFilterValue } = useFilters();
  const selectedStrain = selectFilterValue("strain_name");

  return (
    <Carousel
      title={title ? <h2 className="heading--m">{title}</h2> : undefined}
      cardsPerSlide={5}
      mobileCardWidth={188}
      className={className}
    >
      {promotedStrains.map((strain) => {
        const strainIsSelected = strain.strain_name === selectedStrain;

        return (
          <Button
            key={strain.strain_name}
            href={
              asLink
                ? `/search/shop/promoted-strains?strain_name=${encodeURIComponent(
                    strain.strain_name as string,
                  )}&deal_active=true`
                : undefined
            }
            onClick={() => onClick?.(strain)}
            className="bg-transparent p-xl pb-none rounded-none"
          >
            <div
              className="flex items-center justify-center text-white -rotate-45 aspect-square max-w-[80%] mx-auto"
              style={{ backgroundColor: strain.color }}
            >
              <span className="rotate-45 text-xxl">{strain.label}</span>
            </div>

            <div
              className={classNames(
                "font-bold text-center mt-xxl text-sm text-default",
                {
                  "text-green": !strainIsSelected,
                },
              )}
            >
              {strain.strain_name}
            </div>
          </Button>
        );
      })}
    </Carousel>
  );
};

export default PromotedStrainCarousel;
